module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp3_6005.e4086c82.png";